
import { defineComponent, PropType } from 'vue';


export default defineComponent({
	name: 'validation-alert',
	components: {},

	setup(): {} {
		return {
		};
	},
	beforeCreate() {

	},
	created() {

	},
	props: {
		validationResults: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	data() {
		return {
			alert: false
		}
	},
	watch: {
		validationResults(newVal) {
			if (newVal.length > 0) {
				this.alert = true;
			}
		}
	},
	methods: {

	}
});
